export default __webpack_public_path__ + "static/meshery-skateboard-a47c4e769587e71afd73163cdf121dbf.png";